import { Tabs as MuiTabs, TabsProps } from '@mui/material'

export const Tabs: React.FC<TabsProps> = props => {
  return (
    <MuiTabs
      {...props}
      sx={{
        ...props.sx,
        '& .MuiTabs-indicator': {
          display: 'none',
          ...props.sx?.['& .MuiTabs-indicator'],
        },
      }}
    />
  )
}

export default Tabs
